import { useCallback } from 'react';

import { useRefArray } from './useRefArray';
import { scrollElementIntoViewHorizontally } from '../utils';

export const useScrollArray = () => {
  const { refs: elementRefs, setRef: setElementRef } =
    useRefArray<HTMLLIElement>();

  const scrollIntoView = useCallback(
    (index: number) => {
      if (index < 0 || index >= elementRefs.current.length)
        throw new Error('Invalid index');
      const element = elementRefs.current[index]?.current;
      if (!element) return;

      scrollElementIntoViewHorizontally(document.body, element);
    },
    [elementRefs]
  );

  return { elementRefs, scrollIntoView, setElementRef };
};
